function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAnswer4 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 122 122",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M101.727,101.205c-23.259,23.914 -61.025,24.963 -84.283,2.342c-23.259,-22.622 -23.259,-60.402 -0,-84.316c23.258,-23.913 61.024,-24.963 84.283,-2.341c23.258,22.621 23.258,60.402 -0,84.315Z",
    style: {
      fill: "#78c844"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M119.587,60.412l-2.125,0.014c0.001,0.147 0.001,0.293 0.001,0.44c0.002,31.061 -25.064,56.362 -56.178,56.595c-0.146,0.001 -0.292,0.002 -0.438,0.002c-31.061,0.001 -56.362,-25.063 -56.595,-56.179l0,-0.001c-0.001,-0.149 -0.002,-0.294 -0.002,-0.436c-0.002,-31.061 25.063,-56.362 56.179,-56.596c0.146,-0.001 0.292,-0.001 0.437,-0.001c31.061,-0.002 56.362,25.063 56.596,56.179l-0,-0.003l2.125,-0.014l2.125,-0.016c-0.256,-33.453 -27.45,-60.395 -60.846,-60.396c-0.156,0 -0.313,0 -0.469,0.002c-33.454,0.254 -60.396,27.448 -60.397,60.845c0,0.16 0.001,0.317 0.002,0.47l0,-0.001c0.254,33.454 27.449,60.395 60.845,60.397c0.156,0 0.313,-0.001 0.469,-0.002c33.453,-0.254 60.396,-27.449 60.397,-60.845c0,-0.156 0,-0.312 -0.001,-0.467l-0,-0.003l-2.125,0.016Z",
    style: {
      fill: "#272525",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.507,70.446l-2.034,-0.615c-1.908,6.307 -5.784,11.775 -10.919,15.676c-5.136,3.901 -11.514,6.232 -18.463,6.286l-0.239,0.001c-6.897,-0.001 -13.256,-2.254 -18.407,-6.073c-5.149,-3.819 -9.073,-9.202 -11.065,-15.443l-2.024,0.646l0.015,2.125l63.152,-0.478l-0.016,-2.125l-2.034,-0.615l2.034,0.615l-0.016,-2.125l-63.152,0.478c-0.674,0.005 -1.308,0.331 -1.704,0.878c-0.396,0.546 -0.509,1.25 -0.304,1.893c2.27,7.109 6.73,13.224 12.582,17.565c5.85,4.341 13.109,6.91 20.939,6.909c0.089,0 0.18,-0.001 0.271,-0.001c7.888,-0.059 15.168,-2.717 21.002,-7.152c5.835,-4.434 10.241,-10.645 12.416,-17.829c0.195,-0.646 0.072,-1.348 -0.332,-1.888c-0.405,-0.541 -1.044,-0.858 -1.718,-0.853l0.016,2.125Z",
    style: {
      fill: "#272525",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.013,59.569l11.211,-6.184c0.854,-0.471 1.381,-1.372 1.374,-2.346c-0.008,-0.975 -0.549,-1.868 -1.409,-2.325l-11.304,-6.015c-1.295,-0.689 -2.903,-0.197 -3.592,1.098c-0.69,1.295 -0.198,2.904 1.097,3.593l6.975,3.711l-6.918,3.816c-1.285,0.709 -1.752,2.325 -1.043,3.609c0.709,1.285 2.325,1.752 3.609,1.043Z",
    style: {
      fill: "#272525",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.173,54.413l-6.975,-3.711l6.919,-3.817c1.284,-0.708 1.751,-2.324 1.042,-3.609c-0.708,-1.284 -2.324,-1.751 -3.608,-1.043l-11.213,6.185c-0.853,0.47 -1.38,1.371 -1.373,2.346c0.007,0.974 0.548,1.867 1.409,2.325l11.303,6.014c1.295,0.69 2.904,0.198 3.593,-1.097c0.69,-1.295 0.199,-2.904 -1.097,-3.593Z",
    style: {
      fill: "#272525",
      fillRule: "nonzero"
    }
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAnswer4);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/answer-4.c69ce0f2a8c673a0cf25d365075e6fda.svg";